<script>
export default {
  inject: ['fields'],
  computed: {
    hasAvailabilityStatusOnlyPermission() {
      return this.$fischer.shop.hasAvailabilityStatusOnlyPermission();
    },
  },
  methods: {
    getPrivileges(
      sitecorePrivileges,
      customerPrivileges,
      withLabel,
      ignoreMandatory,
      noShopAccess,
    ) {
      if (!sitecorePrivileges && !this.fields?.fixperiencePrivileges?.length) {
        return null;
      }

      const allPrivileges = [];

      if (sitecorePrivileges?.length) {
        if (withLabel) {
          const privilegesWithLabel = sitecorePrivileges.map((el) => ({
            headline: el.headline,
            privileges: this.loopPrivileges(
              el.privileges,
              customerPrivileges,
              ignoreMandatory,
              noShopAccess,
            ),
          }));

          allPrivileges.push(...privilegesWithLabel);
        } else {
          const privileges = this.loopPrivileges(
            sitecorePrivileges,
            customerPrivileges,
            ignoreMandatory,
            noShopAccess,
          );

          allPrivileges.push(...privileges);
        }
      }

      if (
        this.$fischer.user.groups()?.find((group) => group === 'fixperiencemanagergroup') &&
        this.fields?.fixperiencePrivileges?.length
      ) {
        const fixperiencePrivileges = this.fields.fixperiencePrivileges.map((el) => el.fields);
        allPrivileges.push({
          headline: this.$dict.get(
            'online-Shop.Global-Labels.Access-Privileges.FiXperience-Headline',
          ),
          privileges: this.loopPrivileges(fixperiencePrivileges, customerPrivileges),
        });
      }

      return allPrivileges;
    },
    loopPrivileges(
      privilegesData,
      customerPrivileges,
      ignoreMandatory,
      noShopAccess,
      parentSelected,
    ) {
      if (!privilegesData) {
        return null;
      }

      return privilegesData.map((accessPrivilege) => {
        const mandatory =
          !ignoreMandatory &&
          (accessPrivilege.Mandatory === true || accessPrivilege.Mandatory?.value === true);
        const privilegeTitle = accessPrivilege.Title?.value || accessPrivilege.Title;
        const privilegeValue = accessPrivilege.Value?.value || accessPrivilege.Value;
        let selected = mandatory;
        let disabled = parentSelected || mandatory || false;

        // disable shop privilege if not authorized
        if (!accessPrivilege.Global && noShopAccess) {
          selected = false;
          disabled = true;
        }

        if (!mandatory && customerPrivileges) {
          selected = customerPrivileges.some(
            (userAccessPrivilege) => privilegeValue === userAccessPrivilege.uid,
          );
        }

        return {
          name: privilegeTitle,
          value: privilegeValue,
          disabled,
          selected,
          subGroups: this.loopPrivileges(
            accessPrivilege.Subgroups,
            customerPrivileges,
            ignoreMandatory,
            noShopAccess,
            selected,
          ),
        };
      });
    },
    hasActivePrivilege(privileges) {
      if (!privileges) {
        return false;
      }

      return privileges.some((item) => item.selected || this.hasActivePrivilege(item.subGroups));
    },
  },
};
</script>
